export const HomeLink = '/';
export const DoctorLink = '/doctor';
export const AppLink = '/app';
export const TestimonialLink = '/testimonial';
export const AboutLink = '/about';
